import React, { useState } from 'react';
import {
  Card,
  CardBody,
  Label,
  Row,
  Col,
  FormGroup,
  Input, Alert,
} from 'reactstrap';
import isEmail from 'validator/lib/isEmail';
import CardText from 'reactstrap/es/CardText';
import LaddaButton, { ZOOM_OUT } from 'react-ladda';
import { Link } from 'react-router-dom';
import { api_forgotUsername } from '../../utils/Auth/AuthService';
import { defaultErrorFeedback } from '../../actions/feedback';
import Section from '../../components/Section';
import Tick from '../../components/SvgIcons/Tick';
import SimpleLoader from '../../components/SimpleLoader';
import ApiErrorResolver from "../../helpers/ApiErrorResolver";
import SynturaBtn, { ButtonType, ButtonSize } from '../../components/SynturaBtn';
import SynturaLogo from '../../components/SVGS/logo';

const ForgotUsername = () => {

  const [email, setEmail] = useState('');
  const [error, setError] = useState<boolean>(false);
  const [apiErrors, setApiErrors] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleInput = (e) => {

    setError(false);
    setEmail(e.target.value);

  };

  const handleSubmit = () => {

    setApiErrors([])
    setSuccess(false);
    if (!isEmail(email)) {

      setError(true);
      return;

    }

    setLoading(true);
    api_forgotUsername(email).then((result) => {

      if (result.status === 200) {

        setSuccess(true);

      } else if (result.status === 422) {

        setApiErrors(ApiErrorResolver(result.data));

      } else {

        defaultErrorFeedback();

      }
      setLoading(false);

    });

  };

  if (success) {

    return (
      <div className="app flex-row align-items-center animated fadeIn syntura-dark-bg">
        <div className="container ">
          <div className="row justify-content-center">
            <Col md={8}>
              <Card className="mb-0 white-card-bg">
                <CardBody>
                  <Row>
                    <Col className="p-3 mb-4 d-flex justify-content-center">
                      <SynturaLogo textFill="#000" />
                    </Col>
                  </Row>
                  <div className="d-flex justify-content-center align-items-center py-4">
                    <Col>
                      <div className="mb-4">
                        <div style={{ fontWeight: 600 }} className="h4 text-dark text-center">Your request has been submitted</div>
                      </div>

                      <div className="d-flex justify-content-center">
                        {' '}
                        <Tick cssClass="large-green-tick" />
                      </div>
                      <div className="d-flex justify-content-center">
                      <Link to="/login">
                        <SynturaBtn
                            size={ButtonSize.SMALL}
                            variant={ButtonType.PRIMARY}
                          >
                            Login
                        </SynturaBtn>
                      </Link>
                      </div>
                    </Col>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </div>
        </div>
      </div>
    );

  }

  if (!success) {

    return (
      <div className="app flex-row align-items-center animated fadeIn syntura-dark-bg">
        <div className="container">
          <div className="row justify-content-center">
            <Col md={8}>
              <Card className="white-card-bg">
                <CardBody>
                  <Row>
                    <Col className="p-3 mb-4">
                      <SynturaLogo textFill="#000" />
                    </Col>
                  </Row>
                  {apiErrors.length > 0 && (
                    <Row>
                      <Col className="p-3 mb-0">
                        <Alert color={"danger"}>{apiErrors.map((error, index) => {
                          return <p className={'mb-0'} key={'error' + index}>{error}</p>;
                        })}</Alert>
                      </Col>
                    </Row>
                  )}
                  <Section title="Username Recovery">
                    <CardText>
                      Enter the email address associated with your Syntura account. Your username will be sent via email.
                    </CardText>
                    <SimpleLoader loading={loading}>
                      <Row>
                        <Col>
                          <FormGroup className="row">
                            <Label className="col-sm-4 col-form-label" for="email">
                              Email
                            </Label>
                            <div className="col-sm-8">
                              <Input
                                id="email"
                                type="email"
                                className={error ? 'is-invalid' : ''}
                                onChange={handleInput}
                              />
                              {error && (
                                <div className="invalid-feedback">
                                  Invalid email address
                                </div>
                              )}
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="d-flex justify-content-end">
                          <SynturaBtn
                            onClick={handleSubmit}
                            size={ButtonSize.SMALL}
                            variant={ButtonType.PRIMARY}
                          >
                            Submit
                          </SynturaBtn>
                        </Col>
                      </Row>
                    </SimpleLoader>
                  </Section>
                </CardBody>
              </Card>
            </Col>
          </div>
        </div>
      </div>
    );

  }

};

export default ForgotUsername;
